import { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import Dropdown from './Dropdown';
import InputField from './InputField';
import TextOnCaseInput from './TextOnCaseInput';
import { FormGroup } from '@mui/material';
import allActions from '../../actions/product_builder';
import Paper from '@mui/material/Paper';
import { useGetImpQuery, useGetRushQuery } from '../../utils/callApis';
import TextOnCaseDropdown from './TextOnCaseDropdown';
import { useTranslation } from 'react-i18next';
// import TermsAndConditions from './TermsAndConditions';

const FinalizeSection = () => {
    const { t } = useTranslation();
    let actionCreator = allActions.finalizeAction;
    let pricingCreator = allActions.priceActions;
    let summaryState = allActions.categoryActions;
    const dispatch = useDispatch();
    let formInfo = useSelector((state) => state.rootReducer.finalizeForm);

    const [isTextOnCase, setIsTextOnCase] = useState(
        formInfo.isTextOnCase !== undefined ? formInfo.isTextOnCase : ''
    );

    const [userName, setUserName] = useState(
        formInfo.userName !== undefined ? formInfo.userName : undefined
    );
    const [userInitials, setUserInitials] = useState(
        formInfo.userInitials !== undefined ? formInfo.userInitials : undefined
    );
    const [impStatus, setImpStatus] = useState(
        formInfo.impStatus ? formInfo.impStatus : { SK: '', displayName: '' }
    );
    const [rushStatus, setRushStatus] = useState(
        formInfo.rushStatus ? formInfo.rushStatus : { SK: '', displayName: '', price: 0 }
    );
    const [bandName, setBandName] = useState(
        formInfo.bandName !== undefined ? formInfo.bandName : undefined
    );
    const [topTextCase, setTopText] = useState(
        formInfo.textOnTop !== undefined ? formInfo.textOnTop : ''
    );
    const [bottomTextCase, setBottomText] = useState(
        formInfo.textOnBottom !== undefined ? formInfo.textOnBottom : ''
    );
    const [orderNotes, setOrderNotes] = useState(
        formInfo.orderNotes !== undefined ? formInfo.orderNotes : undefined
    );

    // const [termsAccepted, setTerms] = useState(false)

    const handleTextOnCaseOption = (value) => {
        setIsTextOnCase(value);
    };

    const updateRushOptions = (value) => {
        dispatch(allActions.rushActions.setListOfRushOptions(value));
    };

    const updateImpressionText = (value) => {
        setImpStatus(value);
    };

    const updateImpressionOptions = (value) => {
        dispatch(allActions.impressionActions.setListOfImpressionStatus(value));
    };

    const validateName = (name) => {
        return name !== undefined;
    };

    const validateInitials = (initials) => {
        return initials !== undefined && initials.length > 0;
    };

    const validateImp = (status) => {
        if (status.SK.length === 0 || status.displayName.length === 0) {
            return false;
        }
        return true;
    };

    // const updatedTermsAgreement = () => {
    //     setTerms(!termsAccepted);
    // };

    const validateTextOnCase = (option) => {
        if (option === '') {
            return false;
        } else {
            if (option === true) {
                return topTextCase.length > 0 || bottomTextCase.length > 0;
            } else {
                return true;
            }
        }
    };

    const validateRush = (rush) => {
        if (rush.SK.length === 0 || rush.displayName.length === 0) {
            return false;
        }
        return true;
    };

    const validateChange = (value) => {
        if (
            validateName(value.userName) &&
            validateTextOnCase(value.isTextOnCase) &&
            validateInitials(value.userInitials) &&
            validateRush(value.rushStatus) &&
            validateImp(value.impStatus)
            // termsAccepted === true
        ) {
            let rushPrice = value.rushStatus.price ? value.rushStatus.price : 0;
            batch(() => {
                dispatch(actionCreator.setForm(value));
                dispatch(pricingCreator.setRushProcessing(rushPrice));
            });
        } else {
            dispatch(summaryState.updateSummaryCategory(false));
        }
    };
    // Effect to control state of the summary
    useEffect(() => {
        validateChange({
            userName: userName,
            userInitials: userInitials,
            bandName: bandName,
            impStatus: impStatus ? impStatus : undefined,
            rushStatus: rushStatus,
            isTextOnCase: isTextOnCase,
            textOnTop: topTextCase,
            textOnBottom: bottomTextCase,
            orderNotes: orderNotes
        });
        // eslint-disable-next-line
    }, [
        userName,
        userInitials,
        impStatus,
        rushStatus,
        isTextOnCase,
        topTextCase,
        bottomTextCase,
        orderNotes
    ]);

    return (
        <>
            <Paper elevation={0} style={{ maxHeight: '98%', overflow: 'auto', direction: 'ltr' }}>
                <FormGroup style={{ width: '80%', margin: 'auto' }}>
                    <InputField
                        required
                        name="userName"
                        type={t('finalize.user_name')}
                        control={setUserName}
                        currValue={userName}
                        placeholder={t('finalize.user_name_placeholder')}></InputField>
                    <InputField
                        required
                        name="userInitials"
                        type={t('finalize.user_initials')}
                        control={setUserInitials}
                        currValue={userInitials}
                        placeholder={t('finalize.user_initials_placeholder')}
                        length={3}></InputField>
                    <InputField
                        name="bandName"
                        type={t('finalize.organization_name')}
                        control={setBandName}
                        currValue={bandName}
                        placeholder={t('finalize.organization_name_placeholder')}
                    />
                    <Dropdown
                        name="impStatus"
                        required
                        type={t('finalize.impression_status')}
                        apiFunction={useGetImpQuery}
                        control={updateImpressionText}
                        currValue={impStatus.SK}
                        updateState={updateImpressionOptions}
                    />
                    <TextOnCaseDropdown
                        handleChange={handleTextOnCaseOption}
                        required
                        type={t('finalize.engraving')}
                        currValue={isTextOnCase}
                    />
                    {isTextOnCase ? (
                        <Fragment>
                            <div style={{ paddingBottom: '15px' }}>
                                <TextOnCaseInput
                                    name="textOnTop"
                                    // checked={isTextOnCase}
                                    style={{ marginTop: '5px' }}
                                    control={setTopText}
                                    currValue={topTextCase}
                                    placeholder={t('finalize.text_on_case_top')}
                                    length={26}
                                />
                                <TextOnCaseInput
                                    style={{ marginTop: '5px' }}
                                    name="textOnBottom"
                                    // checked={isTextOnCase}
                                    currValue={bottomTextCase}
                                    control={setBottomText}
                                    placeholder={t('finalize.text_on_case_bottom')}
                                    length={26}
                                />
                            </div>
                        </Fragment>
                    ) : (
                        <></>
                    )}
                    <Dropdown
                        name="rushStatus"
                        type="Rush processing"
                        required
                        apiFunction={useGetRushQuery}
                        currValue={rushStatus.SK}
                        control={setRushStatus}
                        updateState={updateRushOptions}
                    />
                    <InputField
                        name="orderNotes"
                        type={t('finalize.order_notes')}
                        currValue={orderNotes}
                        control={setOrderNotes}
                        placeholder={t('finalize.order_notes_placeholder')}
                        multiline={3}
                    />
                    {/* <TermsAndConditions
                        termsAgreed={termsAccepted}
                        setTerms={(e) => { console.log(e); updatedTermsAgreement(!termsAccepted)}}
                        url={process.env.TERMS_AND_CONDITIONS_URL}
                    /> */}
                </FormGroup>
            </Paper>
        </>
    );
};

export default FinalizeSection;
